import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconSortArrow = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" size={size} {...props}>
        <StyledPath d="M5.714 8.5L0 .5h11.429z" color={color} />
    </StyledSvg>
);
